<app-menu [hasChanges]="loadMenu" [title]="'Bienvenido al sistema administrativo'"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-fluid pl-2 h-screen bg-white">
    <div class="grid flex align-items-start">
        <div class="col-12 md:col-4">
            <div class="text-center">
                <h4>Indicadores para Hoy</h4>
            </div>
            <div class="flex flex-wrap justify-content-between">
                <div class="w-6 p-1 text-center">
                    <div class="p-3 border-2 bg-green-500 border-white  border-round flex align-items-center justify-content-center">
                        <p class="text-lg text-white m-0">Venta del día<br>{{ventaDia | currency}}</p>
                    </div>
                </div>
                <div class="w-6 p-1 text-center">
                    <div class="p-3 border-2 bg-primary border-white text-white border-round">
                        <p class="text-lg text-white m-0">Meta del día<br>{{metaDiaria | currency}}</p>
                    </div>
                </div>
                <div class="w-full bg-simescco m-2 text-center border-300 border-round p-3">
                    <p class="text-lg text-white m-0">Alcance: {{metaDiaria ==0?0:(ventaDia/metaDiaria) | percent:'2.1'}}</p>
                </div>
            </div>
            <div class="w-full">
                <p-card class="border-round">
                    <div class="w-full flex justify-content-center">
                        <apx-chart [colors]="chartOptions.fill.colors" [series]="chartOptions.series"
                            [chart]="chartOptions.chart" [labels]="chartOptions.labels" [title]="chartOptions.title"
                            [yaxis]="chartOptions.yaxis" #chart></apx-chart>
                    </div>
                    <p class="p-1 text-center">Realice la asignación de vendedores que estan participando para lograr la
                        meta asignada</p>
                    <ng-template pTemplate="footer">
                        <div class="flex justify-content-center">
                            <button pButton class="p-button p-button-success" label="Asignación de vendedores"
                                icon="pi pi-eye" (click)="verAsignacionSales()"></button>
                        </div>
                    </ng-template>
                </p-card>
            </div>
            <hr>
        </div>
        <div class="w-full md:w-8 flex flex-wrap">
            <div class="text-center w-full">
                <h4>Venta acumulada del Mes Actual</h4>
            </div>
            <div class="w-full">
                <label>Seleccione la fecha de consulta</label>
                <div class="flex w-full align-items-center">
                    <p-datepicker [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" showIcon
                        dateFormat="yy-mm-dd" class="w-full" inputStyleClass="w-full" />
                    <div>
                        <button pButton icon="pi pi-search" class="p-button p-button-success"
                            (click)="getInfoCumulativeSales()"></button>
                    </div>
                </div>
            </div>
            <div class="col-12 grid">
                <div class="col-12 md:col-6">
                    <p-card class="border-round">
                        <ng-template pTemplate="header">
                            <div class="text-center pt-2">
                                <h4>Discriminación de Medios de Pago</h4>
                            </div>
                        </ng-template>
                        <div class="card flex justify-content-center">
                            <apx-chart [colors]="chartOptions1.fill.colors" [series]="chartOptions1.series"
                                [chart]="chartOptions1.chart" [dataLabels]="chartOptions1.dataLabels"
                                [plotOptions]="chartOptions1.plotOptions" [xaxis]="chartOptions1.xaxis"
                                [yaxis]="chartOptions1.yaxis" [title]="chartOptions1.title" #chart1></apx-chart>
                        </div>
                    </p-card>
                </div>
                <div class="col-12 md:col-6">
                    <p-card class="border-round">
                        <ng-template pTemplate="header">
                            <div class="text-center pt-2">
                                <h4>Venta Acumulada</h4>
                            </div>
                        </ng-template>
                        <div class="card flex justify-content-center">
                            <apx-chart [colors]="chartOptions2.fill.colors" [series]="chartOptions2.series"
                                [chart]="chartOptions2.chart" [labels]="chartOptions2.labels"
                                [yaxis]="chartOptions2.yaxis" [title]="chartOptions2.title" #chart2></apx-chart>
                        </div>
                        <ng-template pTemplate="footer">
                            <div class="flex justify-content-center">
                                <div class="w-6 p-2 ">
                                    <div class="bg-green-500 p-3 text-center border-round align-items-center justify-content-center flex">
                                        <p class="text-white m-0">Venta acumulada: <br>{{chartOptions2.series[0] | currency}}</p>
                                    </div>
                                </div>
                                <div class="w-6 p-2">
                                    <div class="bg-simescco p-3  text-center border-round align-items-center justify-content-center flex">
                                        <p class="text-white m-0">Meta faltante:<br> {{chartOptions2.series[1] | currency}}</p>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-card>
                </div>

            </div>
        </div>
        <div class="sticky-footer bg-white w-full" *ngIf="alerts.length>0">
            <div class="text-center w-full">
                <h4 class="p-0 m-0">Alertas prioritarias</h4>
            </div>
            <div class="flex flex-wrap justify-content-center">
                <div class="p-message p-message-{{row.type}}" *ngFor="let row of alerts">
                    <span [innerHtml]="row.text"></span>
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>

<p-dialog [(visible)]="display" [modal]="true" [style]="{width:'80%'}">
    <ng-template #header>
        <div class="inline-flex items-center justify-center gap-2 uppercase">Selección de vendedores para inicio de
            jornada</div>
    </ng-template>
    <div class="p-inputgroup w-full">
        <div class="p-inputgroup-addon"><i class="pi pi-search"></i></div>
        <input type="text" class="w-full" pInputText [(ngModel)]="salesFilter" placeholder="Busqueda de vendedores"
            (keyup)="filterSales()" pSize="small" />
    </div>
    <div class="inline-flex items-center justify-center gap-2" *ngFor="let row of listSalesFilter">
        <label for="chk1" class="ml-2"> {{row.label}} </label>
        <p-checkbox inputId="chk1" value="{{row.id}}" [(ngModel)]="selectedSales"></p-checkbox>
    </div>
    <ng-template #footer>
        <button pButton class="p-button p-button-success" label="Asignar vendedores" icon="pi pi-check-circle"
            (click)="asignarSales()"></button>
    </ng-template>
</p-dialog>
<app-footer></app-footer>